import React, {useCallback, useState} from 'react';
import {Box, IconButton, Tooltip, Typography} from "@mui/material";
import {AsyncSelect} from "../../../../../components/forms";
import {HttpCacheOperacion} from "../../../api/httpCacheOperacion";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import {SubmitHandler, useForm} from "react-hook-form";
import {CLFBDetalle, schemaCLFBDetalle} from "../types/types";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {OperacionCLFBDetalleFields} from "../types/fields";
import {OperacionCLFBConcentracionesFields} from "../../../types/clfb";

interface SeccionCLFBCampoConcentracionProps {
  detalle: CLFBDetalle,
  codPais: number,
  permiteEditar: boolean,
  handleConfirm: (data: CLFBDetalle) => void
}

function CLFBDetalleCampoLimite({
                                  detalle,
                                  codPais,
                                  permiteEditar,
                                  handleConfirm
                                }: SeccionCLFBCampoConcentracionProps) {

  const [editable, setEditable] = useState<boolean>(false);

  const {control, handleSubmit} = useForm<CLFBDetalle>({
    resolver: zodResolver(schemaCLFBDetalle),
    defaultValues: {
      ...detalle
    }
  })

  const getConcentraciones = useCallback(() =>
      HttpCacheOperacion.getConcentraciones(codPais)
    , [codPais])

  const onUpdateDetalle: SubmitHandler<CLFBDetalle> = (data) => {
    handleConfirm(data)
  }

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='nowrap'>
      {
        (permiteEditar && editable) ?
          <AsyncSelect
            control={control}
            name={OperacionCLFBDetalleFields.CreditLimitConcentracionMaxima}
            label='Concentración Máxima'
            fullWidth
            selectNotNulleable
            loadOptions={getConcentraciones}
            valueField={OperacionCLFBConcentracionesFields.ConcentracionImporte}
          />
          :
          <Typography noWrap variant='body2'>
            {numberFormatter.toStringWithPercentage(detalle[OperacionCLFBDetalleFields.CreditLimitConcentracionMaxima], 0, 0)}
          </Typography>
      }
      {
        permiteEditar &&
        (
          editable ?
            <Box display='flex' justifyContent='center' flexWrap='nowrap'>
              <Tooltip title='Cancelar'>
                <IconButton onClick={() => setEditable(false)}>
                  <CancelIcon color='error'/>
                </IconButton>
              </Tooltip>
              <Tooltip title='Confirmar'>
                <IconButton onClick={handleSubmit(onUpdateDetalle)}>
                  <CheckCircleIcon color='success'/>
                </IconButton>
              </Tooltip>
            </Box>
            :
            <Tooltip title='Editar'>
              <IconButton onClick={() => setEditable(true)}>
                <EditIcon color='info'/>
              </IconButton>
            </Tooltip>
        )
      }
    </Box>
  )
}

export default CLFBDetalleCampoLimite;